import Checkbox from "@/components/ui/design-system/Checkbox";

type LibraryTemplateFileProps = {
  name: string;
  thumbnail: string;
  checked: boolean;
  onToggle: () => void;
};

export function LibraryTemplateFile({
  name,
  thumbnail,
  checked,
  onToggle,
}: LibraryTemplateFileProps) {
  const fileName = name.replace(/_/g, " ").replace("sample", "");
  const titleCaseFileName = fileName
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

  return (
    <div>
      <Checkbox
        checked={checked}
        onChange={onToggle}
        label={titleCaseFileName}
        showPointer
        className="mb-4 text-lg font-semibold"
        aria-label={`Select ${titleCaseFileName}`}
      />
      <div
        onClick={onToggle}
        className={`w-fit shadow-md transition-all duration-200 cursor-pointer ${
          checked ? "ring-2 ring-brand-500" : "opacity-60"
        }`}
      >
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          data-testid="template-file-preview-image"
          src={thumbnail}
          height={562}
          width={400}
        />
      </div>
    </div>
  );
}
